<script setup lang="ts">import { ref as _ref } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineProps({
  value: null
});
import { watch } from 'vue';
import { AlertingHookDto, AlertingHookService } from '@/api';

interface Emit {
  (event: 'input', value: AlertingHookDto[]): void
}
const emit = defineEmits(["input"]);

const { value: selectedSlackChannels } = __MACROS_useVModel(["value", undefined, "input"]);

let loading = _ref(false);
let alertingHooks = _ref<AlertingHookDto[]>([]);
const searchString = _ref('');

const clear = () => {
  selectedSlackChannels.value = [];
  emit('input', selectedSlackChannels.value);
};

const fetchSlackTags = async () => {
  loading.value = true;
  const { data } = await AlertingHookService.getAllAlertingHooks({ type: AlertingHookDto.type.SLACK, itemsPerPage: -1 });
  alertingHooks.value = data!;
  loading.value = false;
};

watch(() => searchString.value, () => {
  fetchSlackTags();
});
</script>

<template lang="pug">
#slack-tag-selector( style="position: relative;" )
  v-autocomplete.tag-selector(
    v-model="selectedSlackChannels"
    v-bind='$attrs'
    v-on='$listeners'
    :loading="loading"
    :items="alertingHooks"
    :search-input.sync="searchString"
    :hint="$t('monitor_wizard.notification_method.slack_channels_hint')"
    @change="searchString=''"
    attach="#slack-tag-selector"
    @click:clear="clear"
    :placeholder="$t('common.words.type_to_search')"
    item-value="id"
    item-text="name"
    data-track="slack-tag-selector"
    cache-items dense outlined
    hide-no-data persistent-hint
    return-object multiple clearable )

    template(v-slot:label)
      span {{ $t('monitor_wizard.notification_method.slack_channels') }}
</template>
